import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueRouter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_router.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import ExploreProjectsApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/projects/components/app.vue?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import { EXPLORE_PROJECTS_TABS } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/projects/constants.js?vue3';

Vue.use(VueRouter);
Vue.use(VueApollo);

export const createRouter = (basePath) => {
  return new VueRouter({
    routes: [
      {
        name: 'root',
        path: '/',
        component: ExploreProjectsApp,
      },
      ...EXPLORE_PROJECTS_TABS.map(({ value }) => ({
        name: value,
        path: `/${value}`,
        component: ExploreProjectsApp,
      })),
    ],
    mode: 'history',
    base: basePath,
  });
};

export const initExploreProjects = () => {
  const el = document.getElementById('js-explore-projects');

  if (!el) return null;

  const { basePath, initialSort, programmingLanguages } = convertObjectPropsToCamelCase(el.dataset);

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(),
  });

  return initVueApp({
    el,
    router: createRouter(basePath),
    apolloProvider,
    name: 'ExploreProjectsRoot',
    component: ExploreProjectsApp,
    props: {
      initialSort,
      programmingLanguages: JSON.parse(programmingLanguages),
    },
  });
};
